
import { RoleProtectedRoute } from "@/components/auth/RoleProtectedRoute"
import { ImageUpload } from "@/components/instagram/ImageUpload"
import { useState } from "react"
import { Button } from "@/components/ui/button"
import { supabase } from "@/integrations/supabase/client"
import { useToast } from "@/hooks/use-toast"

export default function Settings() {
  const [image, setImage] = useState<File | null>(null)
  const [imagePreview, setImagePreview] = useState<string | null>(null)
  const [isUploading, setIsUploading] = useState(false)
  const { toast } = useToast()

  const handleUploadBackground = async () => {
    if (!image) {
      toast({
        variant: "destructive",
        title: "Erro",
        description: "Por favor, selecione uma imagem primeiro.",
      })
      return
    }

    try {
      setIsUploading(true)

      // Upload the file to Supabase storage
      const fileExt = image.name.split('.').pop()
      const fileName = `${crypto.randomUUID()}.${fileExt}`
      
      const { error: uploadError } = await supabase.storage
        .from('backgrounds')
        .upload(fileName, image)

      if (uploadError) throw uploadError

      // Get the public URL
      const { data: { publicUrl } } = supabase.storage
        .from('backgrounds')
        .getPublicUrl(fileName)

      // Update all profiles with the new background URL
      const { error: updateError } = await supabase
        .from('profiles')
        .update({ background_url: publicUrl })
        .not('id', 'is', null)

      if (updateError) throw updateError

      toast({
        title: "Sucesso",
        description: "Imagem de fundo atualizada com sucesso!",
      })

      // Clear the form
      setImage(null)
      setImagePreview(null)
    } catch (error) {
      console.error('Error:', error)
      toast({
        variant: "destructive",
        title: "Erro",
        description: "Ocorreu um erro ao fazer upload da imagem. Por favor, tente novamente.",
      })
    } finally {
      setIsUploading(false)
    }
  }

  return (
    <RoleProtectedRoute allowedRoles={["admin"]}>
      <div className="container mx-auto py-10">
        <div className="space-y-6">
          <div>
            <h2 className="text-2xl font-bold mb-4">Configurações</h2>
            <p className="text-muted-foreground">Configure as opções do sistema.</p>
          </div>

          <div className="space-y-4">
            <div className="max-w-xl">
              <h3 className="text-lg font-semibold mb-2">Imagem de Fundo</h3>
              <p className="text-sm text-muted-foreground mb-4">
                Faça upload de uma nova imagem de fundo para a página inicial. 
                Esta imagem será exibida para todos os usuários.
              </p>
              
              <ImageUpload
                image={image}
                imagePreview={imagePreview}
                onImageChange={setImage}
                onImagePreviewChange={setImagePreview}
              />
              
              {(image || imagePreview) && (
                <Button 
                  onClick={handleUploadBackground}
                  disabled={isUploading}
                  className="mt-4"
                >
                  {isUploading ? "Enviando..." : "Atualizar Imagem de Fundo"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </RoleProtectedRoute>
  )
}
